// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as GroupBuying${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as GroupBuyingContent } from './content.vue'
import { default as GroupBuyingContentGoods } from './content_goods.vue'
import { default as GroupBuyingContentRule } from './content_rule.vue'
import { default as GroupBuyingContentStatus } from './content_status.vue'
import { default as GroupBuyingMore } from './more.vue'
import { default as GroupBuyingPendingPaymentOrder } from './pending_payment_order.vue'
import { default as GroupBuyingView } from './view.vue'
// @endindex

export const GroupBuyingComponents = {
  // @index('./*.vue', (f, _) => `GroupBuying${_.pascal(f.name)},`)
  GroupBuyingContentGoods,
  GroupBuyingContentRule,
  GroupBuyingContentStatus,
  GroupBuyingContent,
  GroupBuyingMore,
  GroupBuyingPendingPaymentOrder,
  GroupBuyingView,
  // @endindex
}
